import { useDispatch, useSelector } from 'react-redux'
import { Checkbox } from '../../../../common/html/checkbox'
import { TooltipEmail } from '../../TooltipEmail'
import { changeSettingTable, selectDataTable } from '../store/slice'

export const EmailCell = ({ rowId }) => {
  const dispatch = useDispatch()

  const dataRow = useSelector(selectDataTable(rowId))

  const onChange = (isCheck) => {
    dispatch(
      changeSettingTable({
        id: rowId,
        value: {
          ...dataRow,
          sendEmail: isCheck,
        },
      }),
    )
  }

  return (
    <TooltipEmail
      contentClass="positionAbsolute wh100"
      contentStyle={{ top: 0, left: 0 }}
      children={(isEmailActive) => (
        <Checkbox
          checked={dataRow.sendEmail}
          onChange={onChange}
          allowChange={isEmailActive && dataRow?.sendNotification}
          appendStyle={{ justifyContent: 'center', height: '100%' }}
        />
      )}
    />
  )
}
